// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WJ4B","name":"styles_name__3YAUY","phone":"styles_phone__1srwy"};